import React from "react";
import { Virtuoso } from "react-virtuoso";
import { DigitalWaiver, Experience } from "types";
import { useAutoFetchCollection } from "../../../hooks/useAutoFetchCollection";
import { useInfiniteCollection } from "../../../hooks/useInfiniteCollection";
import { ErrorBoundary } from "../../ErrorBoundary";
import { Loader } from "../../Loader";
import { DigitalWaiversItem } from "./DigitalWaiversItem";

interface DigitalWaiversListProps {
    height: number;
}

export const DigitalWaiversList = ({ height }: DigitalWaiversListProps) => {
    const {
        data: waiverTemplates,
        isLoading,
        fetchNextPage,
        isFetchingNextPage,
        hasNextPage,
    } = useInfiniteCollection<DigitalWaiver>("waiverTemplates");

    const { data: experiences, isLoading: isLoadingExperiences } = useAutoFetchCollection<Experience>("experiences");

    return (
        <div className="flex h-full lg:flex-row">
            {waiverTemplates.length > 0 ? (
                <Virtuoso
                    style={{ height }}
                    className="w-full"
                    data={waiverTemplates}
                    endReached={async () => {
                        if (hasNextPage) {
                            fetchNextPage();
                        }
                    }}
                    itemContent={(index, waiverTemplate) => {
                        return (
                            <ErrorBoundary fallbackMessage={`Cannot render waiver template ${waiverTemplate.id}`}>
                                <DigitalWaiversItem
                                    key={waiverTemplate.id}
                                    waiverTemplate={waiverTemplate}
                                    waiverTemplates={waiverTemplates}
                                    experiences={experiences}
                                    onPreview={(template: DigitalWaiver) => window.open(template.url, "_blank")}
                                />
                            </ErrorBoundary>
                        );
                    }}
                />
            ) : (
                <NoDigitalWaiversMessage isLoading={isLoading} />
            )}

            {isFetchingNextPage || isLoadingExperiences ? <Loader /> : null}
        </div>
    );
};

const NoDigitalWaiversMessage = ({ isLoading }: { isLoading: boolean }) => {
    return (
        <div className="m-4 mx-2 p-2 text-gray-darker">
            {isLoading ? (
                <Loader size="tiny" className="!p-1" text="Loading Digital Waivers" />
            ) : (
                <span>No digital waivers found</span>
            )}
        </div>
    );
};
